export default {
	namespaced: true,
	state: {
		endpoint: '/nbu/NbuReasonStopP1',
		name: 'NbuReasonStopP1',
		title: {
			single: 'NbuReasonStopP1',
			plural: 'NbuReasonStopP1s'
		},
		icon: 'mdi-account',
		item: {},
		items: [
			{
				"id": "7",
				"code": null,
				"name": "виявлення фактів приймання страхових (перестрахових) премій та страхових (перестрахових) виплат страховими посередниками без дотримання вимог щодо відкриття та ведення поточного рахунку із спеціальним режимом використання, встановлених цим Законом",
				"caption": "виявлення фактів приймання страхових (перестрахових) премій та страхових (перестрахових) виплат страховими посередниками без дотримання вимог щодо відкриття та ведення поточного рахунку із спеціальним режимом використання, встановлених цим Законом",
				"isBlocked": false
			},
			{
				"id": "4",
				"code": null,
				"name": "відсутність інформації про проходження страховим посередником - фізичною особою та фізичною особою - підприємцем, керівником з реалізації страхового посередника - юридичної особи, страхового або перестрахового брокера - нерезидента, фізичної особи - підприємця навчання або підвищення кваліфікації у строки, визначені цим Законом",
				"caption": "відсутність інформації про проходження страховим посередником - фізичною особою та фізичною особою - підприємцем, керівником з реалізації страхового посередника - юридичної особи, страхового або перестрахового брокера - нерезидента, фізичної особи - підприємця навчання або підвищення кваліфікації у строки, визначені цим Законом",
				"isBlocked": false
			},
			{
				"id": "2",
				"code": null,
				"name": "встановлення фактів подання страховим посередником недостовірної інформації у документах, на підставі яких запис про таку особу внесено до Реєстру посередників",
				"caption": "встановлення фактів подання страховим посередником недостовірної інформації у документах, на підставі яких запис про таку особу внесено до Реєстру посередників",
				"isBlocked": false
			},
			{
				"id": "9",
				"code": null,
				"name": "встановлення фактів подання страховим посередником недостовірної інформації у документах, на підставі яких запис про таку особу та її керівників з реалізації внесено до Реєстру посередників",
				"caption": "встановлення фактів подання страховим посередником недостовірної інформації у документах, на підставі яких запис про таку особу та її керівників з реалізації внесено до Реєстру посередників",
				"isBlocked": false
			},
			{
				"id": "24",
				"code": null,
				"name": "інше",
				"caption": "інше",
				"isBlocked": false
			},
			{
				"id": "3",
				"code": null,
				"name": "наявність заборони на здійснення відповідної діяльності фізичною особою та фізичною особою - підприємцем за рішенням суду, що набрало законної сили",
				"caption": "наявність заборони на здійснення відповідної діяльності фізичною особою та фізичною особою - підприємцем за рішенням суду, що набрало законної сили",
				"isBlocked": false
			},
			{
				"id": "1",
				"code": null,
				"name": "невідповідність страхового посередника - фізичної особи та фізичної особи - підприємця, керівників з реалізації страхового посередника - юридичної особи та представництва страхового або перестрахового брокера - нерезидента, страхового посередника - фізичної особи - підприємця вимогам, передбаченим\u00A0підпунктом 1 частини першої статті 73\u00A0цього Закону",
				"caption": "невідповідність страхового посередника - фізичної особи та фізичної особи - підприємця, керівників з реалізації страхового посередника - юридичної особи та представництва страхового або перестрахового брокера - нерезидента, страхового посередника - фізичної особи - підприємця вимогам, передбаченим\u00A0підпунктом 1 частини першої статті 73\u00A0цього Закону",
				"isBlocked": false
			},
			{
				"id": "15",
				"code": null,
				"name": "невідповідність страхового посередника - фізичної особи та фізичної особи - підприємця, керівників з реалізації страхового посередника - юридичної особи та представництва страхового або перестрахового брокера - нерезидента, страхового посередника - фізичної особи - підприємця вимогам, передбаченим\u00A0підпунктом 2 частини першої статті 73\u00A0цього Закону",
				"caption": "невідповідність страхового посередника - фізичної особи та фізичної особи - підприємця, керівників з реалізації страхового посередника - юридичної особи та представництва страхового або перестрахового брокера - нерезидента, страхового посередника - фізичної особи - підприємця вимогам, передбаченим\u00A0підпунктом 2 частини першої статті 73\u00A0цього Закону",
				"isBlocked": false
			},
			{
				"id": "16",
				"code": null,
				"name": "невідповідність страхового посередника - фізичної особи та фізичної особи - підприємця, керівників з реалізації страхового посередника - юридичної особи та представництва страхового або перестрахового брокера - нерезидента, страхового посередника - фізичної особи - підприємця вимогам, передбаченим\u00A0підпунктом 3 частини першої статті 73\u00A0цього Закону",
				"caption": "невідповідність страхового посередника - фізичної особи та фізичної особи - підприємця, керівників з реалізації страхового посередника - юридичної особи та представництва страхового або перестрахового брокера - нерезидента, страхового посередника - фізичної особи - підприємця вимогам, передбаченим\u00A0підпунктом 3 частини першої статті 73\u00A0цього Закону",
				"isBlocked": false
			},
			{
				"id": "17",
				"code": null,
				"name": "невідповідність страхового посередника - фізичної особи та фізичної особи - підприємця, керівників з реалізації страхового посередника - юридичної особи та представництва страхового або перестрахового брокера - нерезидента, страхового посередника - фізичної особи - підприємця вимогам, передбаченим\u00A0підпунктом 4 частини першої статті 73\u00A0цього Закону",
				"caption": "невідповідність страхового посередника - фізичної особи та фізичної особи - підприємця, керівників з реалізації страхового посередника - юридичної особи та представництва страхового або перестрахового брокера - нерезидента, страхового посередника - фізичної особи - підприємця вимогам, передбаченим\u00A0підпунктом 4 частини першої статті 73\u00A0цього Закону",
				"isBlocked": false
			},
			{
				"id": "8",
				"code": null,
				"name": "неподання повідомлення про новий договір страхування відповідальності страхового посередника, передбачений статтею 74 цього Закону (якщо страховий посередник отримує страхові та/або перестрахові премії, страхові та/або перестрахові виплати)",
				"caption": "неподання повідомлення про новий договір страхування відповідальності страхового посередника, передбачений статтею 74 цього Закону (якщо страховий посередник отримує страхові та/або перестрахові премії, страхові та/або перестрахові виплати)",
				"isBlocked": false
			},
			{
				"id": "5",
				"code": null,
				"name": "проведення державної реєстрації припинення страхового посередника як юридичної особи, представництва страхового або перестрахового  брокера - нерезидента або державної реєстрації припинення підприємницької діяльності страхового посередника, який є фізичною особою - підприємцем",
				"caption": "проведення державної реєстрації припинення страхового посередника як юридичної особи, представництва страхового або перестрахового  брокера - нерезидента або державної реєстрації припинення підприємницької діяльності страхового посередника, який є фізичною особою - підприємцем",
				"isBlocked": false
			},
			{
				"id": "6",
				"code": null,
				"name": "смерть фізичної особи, фізичної особи - підприємця або визнання такої особи безвісно відсутньою чи померлою за рішенням суду",
				"caption": "смерть фізичної особи, фізичної особи - підприємця або визнання такої особи безвісно відсутньою чи померлою за рішенням суду",
				"isBlocked": false
			}
		],
	},
}
